function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Legend_4_"
}, React.createElement("g", {
  id: "Legend_1_"
}, React.createElement("text", {
  transform: "translate(68.322 363.365)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Bexar"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Dallas")), React.createElement("text", {
  transform: "translate(51.69 363.365)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "a"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "b"))), React.createElement("g", {
  id: "Legend_2_"
}, React.createElement("text", {
  transform: "translate(149.603 363.365)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "El Paso"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Harris")), React.createElement("text", {
  transform: "translate(132.97 363.365)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "c"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "d"))), React.createElement("g", {
  id: "Legend_3_"
}, React.createElement("text", {
  transform: "translate(230.884 363.365)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Tarrant"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Travis")), React.createElement("text", {
  transform: "translate(214.252 363.365)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "e"), React.createElement("tspan", {
  x: 0,
  y: 15.6,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13
}, "f"))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid_1_"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(23.507 317.777)"
}, "70"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(24.755 223.22)"
}, "75"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(22.87 123.724)"
}, "80"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(283.77 317.777)"
}, "70"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(283.77 223.22)"
}, "75"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(283.77 123.724)"
}, "80"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(283.77 30.778)"
}, "85"), React.createElement("text", {
  transform: "rotate(-90 48.974 23.864)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 10
}, "Group life"), React.createElement("tspan", {
  x: -9.3,
  y: 12,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 10
}, "expectancy")), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(49.806 11.54)"
}, "Black"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(131.092 11.54)"
}, "Hispanic"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(212.38 11.54)"
}, "White"), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M49.8 21.5h65.6v296.3H49.8z"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M131.1 21.5h65.6v296.3h-65.6z"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M212.4 21.5H278v296.3h-65.6z"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M49.8 169.6h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M49.8 70.8h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M49.8 219h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M49.8 120.2h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M131.1 268.4h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M131.1 169.6h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M131.1 70.8h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M131.1 219h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M131.1 120.2h65.6"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M212.4 268.4H278"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M212.4 169.6H278"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M212.4 70.8H278"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M212.4 219H278"
}), React.createElement("path", {
  stroke: "#8b93c4",
  strokeWidth: 0.956,
  d: "M212.4 120.2H278"
}), React.createElement("path", {
  stroke: "#ccc",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.32,
  d: "M49.8 268.4h65.6"
})), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(51.689 331.663)"
}, "a"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(61.702 331.663)"
}, "b"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(73.03 331.663)"
}, "c"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(82.867 331.663)"
}, "d"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(93.933 331.663)"
}, "e"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(106.24 331.663)"
}, "f"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(132.97 331.663)"
}, "a"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(142.983 331.663)"
}, "b"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(154.31 331.663)"
}, "c"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(164.148 331.663)"
}, "d"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(175.214 331.663)"
}, "e"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(187.522 331.663)"
}, "f"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(214.251 331.663)"
}, "a"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(224.265 331.663)"
}, "b"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(235.592 331.663)"
}, "c"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(245.43 331.663)"
}, "d"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(256.496 331.663)"
}, "e"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(268.803 331.663)"
}, "f"));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bars_1_",
  fill: "#fff"
}, React.createElement("path", {
  d: "M52.5 200.9h7.4v116.9h-7.4z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M63 227.1h7.4v90.7H63z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M73.6 123.7H81v194.1h-7.4z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M84.2 229.6h7.4v88.1h-7.4z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M94.8 193.6h7.4v124.1h-7.4z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M105.4 177.2h7.4v140.6h-7.4z",
  opacity: 0.4
}), React.createElement("path", {
  d: "M133.7 128.7h7.4v189.1h-7.4z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M144.3 35.8h7.4v282h-7.4z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M154.9 95.4h7.4v222.4h-7.4z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M165.5 41.9h7.4v275.8h-7.4z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M176.1 35.6h7.4v282.2h-7.4z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M186.7 54.1h7.4v263.7h-7.4z",
  opacity: 0.4
}), React.createElement("path", {
  d: "M215 146.1h7.4v171.7H215z",
  opacity: 0.9
}), React.createElement("path", {
  d: "M225.6 147.6h7.4v170.2h-7.4z",
  opacity: 0.8
}), React.createElement("path", {
  d: "M236.2 163.6h7.4v154.2h-7.4z",
  opacity: 0.7
}), React.createElement("path", {
  d: "M246.8 143h7.4v174.8h-7.4z",
  opacity: 0.6
}), React.createElement("path", {
  d: "M257.4 149.7h7.4v168.1h-7.4z",
  opacity: 0.5
}), React.createElement("path", {
  d: "M267.9 90h7.4v227.8h-7.4z",
  opacity: 0.4
}));

var SvgSDisparitiesMobileColors = function SvgSDisparitiesMobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Viz",
    x: 0,
    y: 0,
    viewBox: "0 0 300 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,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";
export { SvgSDisparitiesMobileColors as ReactComponent };